import { FC } from 'react';
import { Box, Stack } from '@chakra-ui/react';
import {
  CorrectCheckIcon,
  CustomWarningIcon,
} from '../../atom/icon/ColorIcons';

type Props = {
  label: string;
  isRequered?: boolean;
  noticed?: boolean;
  chkValue?: boolean;
};

const beforeStyle = {
  content: '"必須"',
  padding: '4px 4px 2px 8px',
  backgroundColor: '#C7608C',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '0.6rem',
  letterSpacing: '4px',
  marginRight: '5px',
};

export const RequiredMarkItemLabel: FC<Props> = (props) => {
  const { label, isRequered = true, noticed = true, chkValue = false } = props;
  return (
    <>
      {isRequered ? (
        <Stack direction={'row'}>
          <Box _before={beforeStyle}>{label}</Box>
          {noticed ? (
            <>
              {chkValue ? (
                <CorrectCheckIcon color={'green.300'} />
              ) : (
                <CustomWarningIcon />
              )}
            </>
          ) : (
            <></>
          )}
        </Stack>
      ) : (
        <>{label}</>
      )}
    </>
  );
};
